import {gql} from '@apollo/client'

export const ADD_EDIT_LEAD_SOURCES = gql`
  mutation leadSourceCreateupdateMutation($input: lead_source_createUpdate_mutationInput!) {
    leadSourceCreateupdateMutation(input: $input) {
      leadSource {
        id
        name
        slug
        metadata
      }
      errors {
        field
        messages
      }
    }
  }
`

export const ADD_EDIT_CATEGORY = gql`
  mutation categoryLeadSourceCreateupdateMutation($input: category_lead_source_createUpdate_mutationInput!) {
    categoryLeadSourceCreateupdateMutation(input: $input) {
      categoryLeadSource {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`
